import React, { useEffect, useMemo } from 'react';

import { useSelector } from 'react-redux';

import { AccordionPanel } from 'reaxl';
import { FilterCheckboxes } from 'reaxl-filters';

import getFilterTitle from '@/utilities/getFilterTitle';

import srpFiltersDuck from '@/ducks/srp/srpFiltersDuck.js';

import FilterPlaceholder from './FilterPlaceholder';

function DoorsFilter({
    onOptionChange = () => {},
    onOptionsClear = () => {},
    handleShowExpansion = () => {},
}) {
    const doorsOptions = useSelector(srpFiltersDuck.selectors.getDoorsOptions);
    const doorsValues = useSelector(srpFiltersDuck.selectors.getDoorsValue);

    const filtersErrors = useSelector(
        srpFiltersDuck.selectors.getFiltersErrors
    );

    const filterName = 'doorCode';
    const isExpanded = useSelector((state) => srpFiltersDuck.selectors.isExpansionActive(state, filterName));
    const showFilter = isExpanded && Object.keys(doorsOptions).length !== 0;

    // Transform doorsOptions to format label using value instead of original label for display
    const transformedDoorsOptions = useMemo(() => ({
        ...doorsOptions,
        options: doorsOptions.options?.map((option) => ({
            ...option,
            label: option.value,
        })) || [],
    }), [doorsOptions]);

    const title = getFilterTitle('Number of Doors', doorsValues);
    const filterValues = {
        doorCode: doorsValues,
    };

    // expand the panel if active options inside of it
    useEffect(() => {
        if (doorsValues.length) {
            handleShowExpansion(filterName);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [doorsValues.length]);

    return (
        <AccordionPanel
            contentPadding={5}
            eventKey={filterName}
            data-cmp="DoorFilter"
            title={title}
        >
            {!showFilter && <FilterPlaceholder uniqueKey={filterName} />}
            {showFilter && (
                <FilterCheckboxes
                    filter={transformedDoorsOptions}
                    values={filterValues}
                    onOptionChange={onOptionChange}
                    onOptionsClear={onOptionsClear}
                    errors={filtersErrors}
                    withAccordion={false}
                />
            )}
        </AccordionPanel>
    );
}

export default DoorsFilter;
